import logo from "../../images/logo.jpg";

export const Header = () => {
  return (
    <div className="flex items-center p-4 fixed bg-white z-50 top-0 w-full shadow-lg">
      <img src={logo} alt="toyota-insurance-logo" className="m-auto" />
    </div>
  );
};
